import React from "react";
import {
	Container,
	Typography,
} from "@mui/material";
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

import { SiteAuthHeader } from "../../components/AuthHeader";
import { AuthPaper } from "../../components/AuthPaper";
import { useI18n } from "./locales";
import { AuthForgotPasswordForm } from "./Form";
import { Helmet } from "react-helmet-async";

export function AuthForgotPassword() {
	const { t } = useI18n();

	return (
		<>
			<Helmet>
				<title>{t('Password reset')} — Haohan</title>
			</Helmet>
			<SiteAuthHeader/>
			<main>
				<Container sx={{maxWidth: "md", pb: 8, pt: 14}}>
					<AuthPaper
						leftColumn={{
							title: t('instructions.intro'),
							items: [
								{
									icon: <AlternateEmailIcon color='disabled'/>,
									title: t('instructions.step1')
								},
								{
									icon: <MarkEmailReadIcon color='primary'/>,
									title: t('instructions.step2')
								},
							]
						}}
						rightColumn={(
							<>
								<Typography
									display='block'
									fontWeight='bold'
									mb={.5}
									textAlign='center'
									variant='h6'
								>
									{t('Password reset')}
								</Typography>
								<Typography
									color='textSecondary'
									display='block'
									mb={3}
									textAlign='center'
									variant='body2'
								>
									{t("Use the form bellow if you can't access your account")}
								</Typography>
								<AuthForgotPasswordForm />
							</>
						)}
					/>
				</Container>
			</main>
		</>
	);
}
